module.exports = __webpack_public_path__ + "aec20f9bb2559eae1d75e0e2a2755a3b.png";